var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWomanSingle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    role: "img",
    "aria-label": "woman",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 3,
    stdDeviation: 2,
    floodColor: "#1b2a2d",
    floodOpacity: 0.35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)",
    transform: "translate(18 12) scale(0.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 42c-18 0-32 15-32 55v8c0 5 4 9 9 9h46c5 0 9-4 9-9v-8c0-40-14-55-32-55z",
    fill: "#c05aa2",
    stroke: "#263238",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 110V58",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 110V58",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 28c0-17 12-29 28-29 15 0 27 12 27 29 0 16-6 32-6 32H26s-5-16-5-32z",
    fill: "#3a2620",
    stroke: "#263238",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 7c12 0 22 10 22 22 0 17-9 31-22 31S26 46 26 29C26 17 36 7 48 7z",
    fill: "#f1c27d",
    stroke: "#263238",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 29c8-1 15-7 19-16 8 10 19 13 31 14C73 10 62 0 48 0 33 0 24 11 24 29z",
    fill: "#3a2620",
    stroke: "#263238",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 33,
    r: 3,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 33,
    r: 3,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 45c6 4 12 4 18 0",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanSingle);
export default __webpack_public_path__ + "static/media/woman-single.b1af74d0cdc4b41e0006b647d4159b92.svg";
export { ForwardRef as ReactComponent };